import React, { FC, useState } from 'react';
import { Button, ButtonVariant } from 'components/common/buttons/Button';
import { CentsDataGrid } from 'components/common/dataGrid/dataGrid';
import { IndividualWebhookEndpoint } from 'api/admin/businesses/getWebhookEndpoints';
import { EditWebhookEndpointsModal } from './EditWebhookEndpointsModal';
import styles from './WebhookEndpoints.module.scss';
import { useWebhookEndpoints } from './queries/useWebhookEndpoints';

const COLUMNS = [
  { headerName: 'ID', field: 'id', flex: 1 },
  { headerName: 'Webhook Endpoint', field: 'webhookEndpoint', flex: 3 },
  { headerName: 'Enabled Events', field: 'webhookEventsEnabled', flex: 3 },
];

export const WebhookEndpoints: FC<{
  businessId: number;
}> = ({ businessId }) => {
  const { isLoading, data: webhookEndpoints, refetch } = useWebhookEndpoints(businessId);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [endpoint, setEndpoint] = useState<IndividualWebhookEndpoint | null>(null);

  const handleCreateWebhookEndpointClick = () => {
    setEndpoint(null);
    setShowEditModal(true);
  };

  const handleRowClick = ({ row }: { row: IndividualWebhookEndpoint }) => {
    const { id, webhookEndpoint, webhookEventsEnabled, businessId } = row;

    setEndpoint({ id, webhookEndpoint, webhookEventsEnabled, businessId });
    setShowEditModal(true);
  };

  const handleEditEndpointClose = async (shouldReload: boolean) => {
    if (shouldReload) {
      await refetch();
    }

    setShowEditModal(false);
  };

  return (
    <div className="page-container">
      <div className={styles.header}>
        <Button type={ButtonVariant.CONTAINED} onClick={handleCreateWebhookEndpointClick}>
          Add Webhook Endpoint
        </Button>
      </div>
      <CentsDataGrid
        tableName="webhookEndpoints"
        data={webhookEndpoints}
        columns={COLUMNS}
        onRowClick={handleRowClick}
        isLoading={isLoading}
      />
      {showEditModal && (
        <EditWebhookEndpointsModal
          businessId={businessId}
          isNew={!endpoint}
          endpoint={endpoint}
          onClose={handleEditEndpointClose}
        />
      )}
    </div>
  );
};
